import React, { FC } from "react";
import Image from "next/image";
import styles from "./SmallGridCard.module.css";

type SmallGridCardProps = {
  title: string | null;
  description: string | null;
  image: {
    url?: string | null;
    description?: string | null;
    width?: number | null;
    height?: number | null;
  } | null;
};

const SmallGridCard: FC<SmallGridCardProps> = ({ title, description, image }) => {
  return (
    <div className={styles.card}>
      {image?.url && (
        <Image
          src={image.url}
          alt={image.description ?? ""}
          width={50}
          height={50}
          className={styles.icon}
        />
      )}
      <div className={styles.content}>
        {title && (
          <h4 className={styles.title}>{title}</h4>
        )}
        {description && <p className={styles.description}>{description}</p>}
      </div>
    </div>
  );
};

export default SmallGridCard;
